"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BarInfoNode = void 0;
var _mui = require("@ori-ui/mui");
var _hooks = require("../../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Bold = (0, _mui.styled)('span')((param)=>{
    let { theme } = param;
    return {
        marginRight: theme.spacing(1),
        fontWeight: 'bold'
    };
});
const Wrapper = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        marginLeft: theme.spacing(8)
    };
});
const BarInfoNode = (param)=>{
    let { label, value, dataTestID } = param;
    const { formatMessage } = (0, _hooks.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Wrapper, {
        variant: "caption",
        "data-testid": dataTestID,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Bold, {
                children: formatMessage(label)
            }),
            " ",
            value
        ]
    });
};
exports.BarInfoNode = BarInfoNode;
